import useNetworkStatus from "@hooks/useNetworkStatus";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NetworkGuard = ({ children }) => {
  const isOnline = useNetworkStatus();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isOnline && location.pathname !== "/no-connection") {
      localStorage.setItem("lastLocation", location.pathname + location.search);
      navigate("/no-connection", { replace: true });
    }

    if (isOnline && location.pathname === "/no-connection") {
      const savedLocation = localStorage.getItem("lastLocation") || "/";
      
      localStorage.removeItem("lastLocation");
      
      navigate(savedLocation, { replace: true });
    }
  }, [isOnline, navigate, location.pathname, location.search]);

  return children;
};

export default NetworkGuard;